import React, { useState } from "react";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";

// import JS files
import Header from "../shares/others/Header";

// import others files

const AboutUsCard = (props) => {
  return (
    <>
      <div className="mt-8  bg-mygrays-100 p-4 md:p-8 rounded-lg ">
        <div className="flex flex-col-reverse md:flex-row justify-between items-center">
          <div className="basis-10/12  md:ml-4 mt-4 md:mt-0">
            <Header header={props.header} noAllItems />
            <div className="mt-4 text-justify">
              <span
                className=" text-myblacks-300 mt-4  text-sm md:text-bas "
                style={{ lineHeight: 2.5 }}
              >
                {props.text}
              </span>
            </div>
          </div>
          <div className=" basis-2/12 flex justify-center bg-white rounded-lg p-4">
            <img src={props.logo} className="w-20 h-20 md:w-auto md:h-auto" />
          </div>
        </div>
        {props.showLink ? (
          <div className="mt-8 flex flex-col md:flex-row justify-between items-center bg-white rounded-lg p-4 text-myblues-300 text-sm md:text-base">
            <span className="">ورود به سایت ایرانیان پوشش از طریق لینک:</span>
            <div className="flex items-center mt-4 md:mt-0">
              <a target="_blank" href="https://iranianpooshesh.com/">
                <span className="ml-4 cursor-pointer transition-all hover:scale-105 ">
                  www.iranianpooshesh.com
                </span>
              </a>
              <LanguageOutlinedIcon />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AboutUsCard;
